// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__ViQgV","spinner":"App_spinner__3mrcx"};